export const ASSESSMENT_STATUSES = {
  scheduled: { label: 'Scheduled', color: '#2563eb' },
  in_progress: { label: 'In Progress', color: '#ed6c02' },
  pending_report: { label: 'Pending Report', color: '#7c3aed' },
  pending_review: { label: 'Pending Review', color: '#d97706' },
  under_review: { label: 'Under Review', color: '#7c3aed' },
  approved: { label: 'Approved', color: '#16a34a' },
  revision_needed: { label: 'Revision Needed', color: '#dc2626' },
  completed: { label: 'Completed', color: '#0d9488' },
};

export const SIDEBAR_WIDTH = 260;

export const COGNITO_CONFIG = {
  UserPoolId: 'us-east-1_BgiyvRzCN',
  ClientId: '6jh0pek0fjvel7fdlhrimkm9mn',
};

// Cognito group for mentor/expert reviewers. Backend internally calls this the
// "expert" group; customer-facing copy uses "expert"; mentor-facing UI uses
// "mentor". See project_cwc_mentor_expert_split memory.
export const MENTOR_GROUP = 'expert';
